var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWidgetsBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 75,
    viewBox: "0 0 84 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 15C11.2125 15 13 16.7875 13 19V61C13 62.1 13.9 63 15 63H65C67.2125 63 69 64.7875 69 67C69 69.2125 67.2125 71 65 71H15C9.475 71 5 66.525 5 61V19C5 16.7875 6.7875 15 9 15ZM25 39C27.2125 39 29 40.7875 29 43V51C29 53.2125 27.2125 55 25 55C22.7875 55 21 53.2125 21 51V43C21 40.7875 22.7875 39 25 39ZM41 31V51C41 53.2125 39.2125 55 37 55C34.7875 55 33 53.2125 33 51V31C33 28.7875 34.7875 27 37 27C39.2125 27 41 28.7875 41 31ZM49 35C51.2125 35 53 36.7875 53 39V51C53 53.2125 51.2125 55 49 55C46.7875 55 45 53.2125 45 51V39C45 36.7875 46.7875 35 49 35ZM65 23V51C65 53.2125 63.2125 55 61 55C58.7875 55 57 53.2125 57 51V23C57 20.7875 58.7875 19 61 19C63.2125 19 65 20.7875 65 23Z",
    fill: "#233C7E",
    fillOpacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWidgetsBig);
export default __webpack_public_path__ + "static/media/widgetsBig.ff53c56640fa5f0ecb50257caac4b339.svg";
export { ForwardRef as ReactComponent };